import { put, call, takeLatest } from 'redux-saga/effects';
import * as api from './Api';
import { actions } from './Reducer';
import {
  setMySupplierPrivateInquiryIsLoading,
  // getSupplierPrivateInquirySuccessAction,
  getMySupplierPrivateInquirySuccessAction,
  getMySupplierPrivateInquiriesSuccessAction,
  addProposalBySupplierSuccessAction,
  editProposalBySupplierSuccessAction,
  getMySupplierProposalSuccessAction,
  getMySupplierProposalsSucessAction,
  setMySupplierPrivateInquiryCountAction
} from './Actions';

import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../../../notifications/Actions';


import {
  push
} from 'react-router-redux'


const body = {
  offset: 0,
  size: 10,
  searchTerm: '',
  filterBy: [{ moderated: false }], // for testing only value === true

  // filterSupplierID: "5fb2f3e7b46faf002c50a501",
  sort: 'createdAt',
  dir: 'asc',
};

function* getMySupplierPrivateInquiries({ payload }) {
  const defBody = {...body, ...payload}
  try {
    yield put(setMySupplierPrivateInquiryIsLoading(true));
    const response = yield call(api.getMySupplierPrivateInquiries,defBody);
    const { data } = response;
    const {content, count} = data
    console.log(content)
    yield put(getMySupplierPrivateInquiriesSuccessAction(content));
    yield put(setMySupplierPrivateInquiryCountAction(count));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPrivateInquiryIsLoading(false));
  }
}

function* getSupplierPrivateInquiry({ payload }) {
  const inquireyId = payload;
  const body = {
    inquiryID: inquireyId,
  };

  try {
    yield put(setMySupplierPrivateInquiryIsLoading(true));
    const response = yield call(api.getMySupplierPrivateInquiry, body);
    const { data } = response;
  
    console.log(data)
    yield put(getMySupplierPrivateInquirySuccessAction(data));
    yield put(newSuccessNotificationAction('Get Private Inquiry'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPrivateInquiryIsLoading(false));
  }
}

function* getMySupplierProposals({ payload }) {
  const defBody = {...body, ...payload}
  try {
    yield put(setMySupplierPrivateInquiryIsLoading(true));
    const response = yield call(api.getMySupplierPrivateInquiries, defBody);
    const { data } = response;
    const {content, count} = data
    console.log(content)
    yield put(getMySupplierProposalsSucessAction(content));

  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPrivateInquiryIsLoading(false));
  }
}
function* getSupplierProposal({ payload }) {
  const inquireyId = payload;
  const body = {
    inquiryID: inquireyId,
  };

  try {
    yield put(setMySupplierPrivateInquiryIsLoading(true));
    const response = yield call(api.getMySupplierPrivateInquiry, body);
    const { data } = response;
  
    console.log(data)
    yield put(getMySupplierProposalSuccessAction(data));
    yield put(newSuccessNotificationAction('Get Private Inquiry'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPrivateInquiryIsLoading(false));
  }
}


function* addProposalBySupplier ({payload, trusted}) {
  try{
    yield put(setMySupplierPrivateInquiryIsLoading(true));
    if (trusted){ 
    const response = yield call(api.addProposalBySupplier, payload)
    // console.log(response)
    const {data} = response;
    yield put(addProposalBySupplierSuccessAction(data))
    yield put(newSuccessNotificationAction('Proposal Sent!'))
    yield put(push('/my-private-inquiries-supplier/'))
    } else {

    const response = yield call(api.addStagingProposalBySupplier, payload)
    // console.log(response)
    const {data} = response;
    // yield put(addProposalBySupplierSuccessAction(data))
    yield put(newSuccessNotificationAction('Proposal Sent! Pending'))
    yield put(push('/my-private-inquiries-supplier/'))
    }
  } catch(error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPrivateInquiryIsLoading(false));
  }
}



function* editProposalBySupplier ({payload, trusted}) {
  try{
    yield put(setMySupplierPrivateInquiryIsLoading(true));
    if (trusted) {
    const response = yield call(api.editProposalBySupplier, payload)
    const {data} = response
    yield put(editProposalBySupplierSuccessAction(data))
    yield put(push('/my-private-inquiries-supplier/my-private-proposals/supplier/'))
    yield put(newSuccessNotificationAction('Edit Success!'))
    } else {
    const response = yield call(api.editStagingProposalBySupplier, payload)
    const {data} = response
    // yield put(editProposalBySupplierSuccessAction(data))
    yield put(push('/my-private-inquiries-supplier/my-private-proposals/supplier/'))
    yield put(newSuccessNotificationAction('Edit Success! Pending'))
    }
  } catch(error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setMySupplierPrivateInquiryIsLoading(false));
  }
}

export default function*() {
  yield takeLatest(
    actions.GET_MY_SUPPLIER_PRIVATE_INQUIREY,
    getSupplierPrivateInquiry
  );
  yield takeLatest(
    actions.GET_MY_SUPPLIER_PRIVATE_INQUIRIES,
    getMySupplierPrivateInquiries
  );
    yield takeLatest(
    actions.ADD_PROSPOSAL_BY_SUPPLIER,
    addProposalBySupplier
  )
  yield takeLatest(
    actions.GET_MY_SUPPLIER_PROPOSALS,
    getMySupplierProposals
  )
  yield takeLatest(
    actions.GET_MY_SUPPLIER_PROPOSAL,
    getSupplierProposal
  )
  yield takeLatest(
    actions.EDIT_PROPOSAL_BY_SUPPLIER,
    editProposalBySupplier
  )
}
